"use client";
// wezon / 연혁
import { motion } from "framer-motion";
const historyData = [
  {
    year: 2024,
    events: [
      { month: "12", text: "대전관광공사 관광벤처 우수상 수상" },
      { month: "10", text: "아마존 웹서비스 우수 사회적경제기업 어워드 선정" },
      { month: "02", text: "배리어프리 단체 네트워크 행사 주최" },
    ],
  },
  {
    year: 2023,
    events: [
      { month: "10", text: "두바이 Access Abilities Expo 참가" },
      { month: "07", text: "대전 저상버스 탑승요청 APP 서비스 런칭" },
    ],
  },
  {
    year: 2022,
    events: [
      { month: "12", text: "대전광역시장 표창 (일자리창출)" },
      {
        month: "11",
        text: "교통약자를 위한 저상버스 정보 공유 시스템 및 그 방법 특허",
      },
      { month: "06", text: "문화체육관광부 장관상 수상 (무장애여행)" },
      { month: "06", text: "정보문화산업진흥원 SOS랩 리빙랩톤 대상" },
    ],
  },
  {
    year: 2021,
    events: [
      {
        month: "11",
        text: `과학기술정보통신부 장관 표창
        (과학기술인 협동조합 부문)`,
      },
      {
        month: "10",
        text: `대통령직속 국가균형발전위원회 표창 
        (교통약자를 위한 대전 저상버스 정보공유 시스템 구축 및 실증)`,
      },
      {
        month: "10",
        text: `당진시 보행권 보장 리빙랩 사업 추진 
        (입간판식 경사로 보급) `,
      },
      { month: "06", text: "장애인기업 인증" },
      { month: "03", text: "대전대학교 가족기업 체결" },
    ],
  },
  {
    year: 2020,
    events: [
      { month: "12", text: "충남대학교 배리어프리 사업 선정" },
      {
        month: "08",
        text: "마을 리빙랩 사업 ‘모두를 위한 여행‘ 선정",
      },
      {
        month: "04",
        text: `R&D 대전정보문화산업진흥원 사회문제해결 ICT서비스 기술개발사업 
(교통약자를 위한 대전 저상버스 정보공유 시스템 구축 및 실증) `,
      },
    ],
  },
  {
    year: 2019,
    events: [
      {
        month: "10",
        text: "행정안전부 지역문제해결플랫폼 ‘모두를 위한 여행‘ 선정",
      },

      {
        month: "06",
        text: `R&D 산업통상자원부 커뮤니티 비즈니스 사업 
(블록체인 기반 지역화폐 호혜거래 시스템 개발)`,
      },
      {
        month: "02",
        text: "D-TECH 공모전 대상 (입간판식 경사로)",
      },
    ],
  },
  {
    year: 2018,
    events: [
      {
        month: "09",
        text: "국민해결 소셜리빙랩 '누구나 평등하게 접근가능한 거리조성 프로젝트'",
      },
      {
        month: "07",
        text: "KT그룹희망나눔재단 Social Change Maker 공모전 기술분야 우수상",
      },
      {
        month: "05",
        text: "과학기술인 협동조합 사업화 지원사업 선정",
      },
      {
        month: "03",
        text: "청년협동조합 창업지원사업 인큐베이팅 사업 선정",
      },
    ],
  },
  {
    year: 2017,
    events: [
      {
        month: "12",
        text: "대전광역시 인권작품 및 아이디어 공모전 아이디어 부문 최우수상",
      },
      {
        month: "11",
        text: "신세계 Mini Contest 지원사업 선정",
      },
      {
        month: "09",
        text: "SK 사회성과인센티브 프로젝트 선정",
      },
      {
        month: "09",
        text: "청년 코워킹 스페이스 '대흥 노마드' 개소",
      },
      {
        month: "06",
        text: "‘사단법인 토닥토닥’ MOU 체결",
      },
    ],
  },
  {
    year: 2016,
    events: [
      {
        month: "10",
        text: "‘행복ICT’ MOU 체결",
      },
      {
        month: "10",
        text: "‘사단법인 비영리IT지원센터’ MOU 체결",
      },
      {
        month: "09",
        text: "장애인 인식개선 웹툰 ‘그녀들의 일상’ 출간",
      },
      {
        month: "07",
        text: "기획재정부 장관 표창 (협동조합)",
      },
      {
        month: "04",
        text: "대전광역시장 표창 (장애인 부문)",
      },
    ],
  },

  {
    year: 2015,
    events: [
      {
        month: "12",
        text: "대전광역시장 표창 (사회적경제 활성화)",
      },
      {
        month: "12",
        text: "한국관광공사 스마트 ICT 공모전 장려상",
      },
      {
        month: "12",
        text: "전국사회적기업 네트워크 우수사회적기업 수상",
      },
      {
        month: "11",
        text: "위즈온 정보접근성 공유 컨퍼런스 개최",
      },
      {
        month: "06",
        text: "과학기술인 협동조합 지원사업 선정",
      },
    ],
  },
  {
    year: 2014,
    events: [
      {
        month: "07",
        text: "고용노동부 장관 표창 (사회적기업)",
      },
      {
        month: "06",
        text: "사회적기업 인증",
      },
      {
        month: "04",
        text: "KDB대우증권 Jump Up Social Enterprise Collaboration Project 선정",
      },
      {
        month: "03",
        text: "대전지방고용노동청 고용지표 시스템 구축 감사패",
      },
    ],
  },
  {
    year: 2013,
    events: [
      {
        month: "12",
        text: "중소기업청 스마트앱창업 경진대회 대상",
      },
      {
        month: "12",
        text: "한국사회적기업진흥원 사회적기업가 우수사례 장려상",
      },
      {
        month: "11",
        text: "한밭대학교 K-청년벤처스타 Demo Day 창업경진대회 최우수상",
      },
      {
        month: "11",
        text: "한밭대학교 창업아이템 경진대회 최우수상 (IT분야)",
      },
      {
        month: "10",
        text: "한국연구재단 대학창업경진대회 특별상",
      },
      {
        month: "05",
        text: "위즈온 협동조합 법인전환",
      },
      {
        month: "03",
        text: "현대차 정몽구재단 H-온드림 오디션 펠로 (혁신상) 수상",
      },
      {
        month: "03",
        text: "(예비)사회적기업 지정",
      },
    ],
  },
  {
    year: 2012,
    events: [
      {
        month: "10",
        text: "스마트 나눔 앱 개발 (정보접근성 개선 기획 부문) 장려상",
      },
      {
        month: "09",
        text: "위즈온 (법인으로 보는 단체) 설립",
      },
      {
        month: "05",
        text: "청년등 사회적기업 육성사업 선정",
      },
    ],
  },
];

export default function HistorySection() {
  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20">
        <ul className="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-10">
          {historyData.map((yearItem, i) => (
            <motion.li
              key={yearItem.year}
              className="p-0 md:p-4 flex"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                ease: "easeOut",
                delay: i * 0.1, // 항목마다 순차적으로 등장
              }}
              viewport={{ once: true, amount: 0.2 }}
            >
              {/* 년도 */}
              <p
                className="text-sm sm:text-lg md:text-3xl mr-2 sm:mr-4 md:mr-6 text-black-300 tracking-tight "
                style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              >
                {yearItem.year}
              </p>

              {/* 점 + 세로선 + 이벤트 */}
              <div className="flex gap-1 sm:gap-4">
                {/* 점 + 세로선 */}
                <div className="flex flex-col items-center mt-[4px] md:mt-2">
                  <motion.span
                    className="w-3 h-3 sm:w-[19px] sm:h-[19px] border-4 sm:border-5 border-[#1AB886] rounded-full z-10"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ duration: 0.4, delay: i * 0.1 + 0.1 }}
                    viewport={{ once: true }}
                  />
                  <motion.div
                    className="w-[2px] bg-[#D8D8D8] flex-1 my-2"
                    initial={{ scaleY: 0 }}
                    whileInView={{ scaleY: 1 }}
                    transition={{ duration: 0.5, delay: i * 0.1 + 0.15 }}
                    viewport={{ once: true }}
                    style={{ transformOrigin: "top" }}
                  />
                </div>

                {/* 이벤트 내용 */}
                <div className="flex flex-col gap-3 mt-[-2px] sm:mt-0 sm:gap-4 md:gap-5 ml-1 sm:ml-2 md:ml-3 my-0 md:my-1">
                  {yearItem.events.map((event, idx) => (
                    <motion.div
                      key={idx}
                      className="flex items-start"
                      initial={{ opacity: 0, y: 15 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 0.5,
                        ease: "easeOut",
                        delay: i * 0.1 + idx * 0.08,
                      }}
                      viewport={{ once: true }}
                    >
                      <span
                        className="mr-2 sm:mr-6 text-sm sm:text-base md:text-lg leading-7 min-w-5 md:min-w-8 text-[#ADB1B1] tracking-tight"
                        style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
                      >
                        {event.month}
                      </span>
                      <p
                        className="text-sm sm:text-base md:text-[17px] leading-7 text-black-200 whitespace-pre-line tracking-tight"
                        style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
                      >
                        {event.text}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  );
}
